<template>

  <head>

    <meta charset="utf-8" />
    <title>County Revenue System | Collector Target Tracking</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Revenue management system" name="description" />
    <meta content="County Team" name="author" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body data-sidebar="dark">

  <div id="layout-wrapper">

    <NavigationBar/>
    <div class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Title -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-light p-4 rounded-3 shadow-sm">
                <div>
                  <h4 class="mb-2 font-size-20">
                    <i class="bx bx-target-lock text-primary me-2"></i>
                    Collector Performance & Target Tracking
                  </h4>
                  <p class="text-muted mb-0">Monitor collector performance against daily, monthly & financial year targets</p>
                </div>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0 bg-transparent">
                    <li class="breadcrumb-item"><a href="javascript:void(0);" @click="gotTo('dashboard')" class="text-decoration-none">Dashboard</a></li>
                    <li class="breadcrumb-item active">Target Tracking</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Tabs -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <div class="card-body p-2">
                  <ul class="nav nav-pills nav-justified" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link py-3" :class="{ active: activeTab === 'overview' }" href="javascript:void(0);" @click="switchTab('overview')">
                        <i class="bx bx-grid-alt me-2"></i>
                        <span class="d-none d-md-inline">Target vs Actual</span>
                        <span class="d-md-none">Overview</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link py-3" :class="{ active: activeTab === 'individual' }" href="javascript:void(0);" @click="switchTab('individual')">
                        <i class="bx bx-user me-2"></i>
                        <span class="d-none d-md-inline">Individual Dashboard</span>
                        <span class="d-md-none">Individual</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link py-3" :class="{ active: activeTab === 'performers' }" href="javascript:void(0);" @click="switchTab('performers')">
                        <i class="bx bx-trophy me-2"></i>
                        <span class="d-none d-md-inline">Top/Bottom Performers</span>
                        <span class="d-md-none">Performers</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link py-3 position-relative" :class="{ active: activeTab === 'alerts' }" href="javascript:void(0);" @click="switchTab('alerts')">
                        <i class="bx bx-bell me-2"></i>
                        <span class="d-none d-md-inline">Alerts & Comparison</span>
                        <span class="d-md-none">Alerts</span>
                        <span v-if="alertCount > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style="font-size: 0.65rem;">
                          {{ alertCount > 99 ? '99+' : alertCount }}
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Shared Filters -->
          <div class="row mb-4" v-if="activeTab !== 'individual'">
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                  <h6 class="mb-0"><i class="bx bx-filter-alt text-primary me-2"></i>Filters</h6>
                  <button class="btn btn-sm btn-outline-secondary" @click="toggleFilters">
                    <i class="bx" :class="showFilters ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
                  </button>
                </div>
                <div class="card-body" v-show="showFilters">
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label fw-semibold">
                        <i class="bx bx-time text-primary me-1"></i> Period Type
                      </label>
                      <select v-model="periodType" class="form-select">
                        <option value="daily">Daily Target</option>
                        <option value="monthly">Monthly Target</option>
                        <option value="financialYear">Financial Year Target</option>
                        <option value="custom">Custom Date Range</option>
                      </select>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label fw-semibold">
                        <i class="bx bx-calendar text-primary me-1"></i> Date Range
                      </label>
                      <div class="input-group">
                        <input v-model="dateFrom" type="date" class="form-control">
                        <span class="input-group-text bg-light">to</span>
                        <input v-model="dateTo" type="date" class="form-control">
                      </div>
                      <small class="text-muted">{{ formatDateDisplay(dateFrom) }} — {{ formatDateDisplay(dateTo) }}</small>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label fw-semibold">
                        <i class="bx bx-map text-primary me-1"></i> Sub County
                      </label>
                      <select v-model="selectedSubCounty" class="form-select">
                        <option value="">All Sub Counties</option>
                        <option v-for="sc in subCounties" :key="sc.subCountyID" :value="sc.subCountyID">
                          {{ sc.subCountyName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2 d-flex align-items-end gap-2">
                      <button @click="loadTabData" class="btn btn-primary flex-fill" :disabled="loading">
                        <i v-if="loading" class="bx bx-loader-alt bx-spin me-1"></i>
                        <i v-else class="bx bx-search me-1"></i>
                        Load
                      </button>
                      <button @click="exportCurrentTab" class="btn btn-success" :disabled="loading" title="Export CSV">
                        <i class="bx bxs-download"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ============================= -->
          <!-- TAB 1: TARGET VS ACTUAL       -->
          <!-- ============================= -->
          <div v-if="activeTab === 'overview'">

            <!-- Summary Cards -->
            <div class="row mb-4" v-if="overviewSummary">
              <div class="col-6 col-lg-3">
                <div class="card border-0 shadow-sm overview-card">
                  <div class="card-body text-center">
                    <div class="avatar-sm mx-auto mb-3">
                      <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-20">
                        <i class="bx bx-group"></i>
                      </span>
                    </div>
                    <h5 class="mb-1">{{ overviewSummary.totalCollectors }}</h5>
                    <p class="text-muted mb-0 small">Total Collectors</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-3">
                <div class="card border-0 shadow-sm overview-card">
                  <div class="card-body text-center">
                    <div class="avatar-sm mx-auto mb-3">
                      <span class="avatar-title rounded-circle bg-soft-success text-success font-size-20">
                        <i class="bx bx-check-double"></i>
                      </span>
                    </div>
                    <h5 class="mb-1 text-success">{{ overviewSummary.exceeding }}</h5>
                    <p class="text-muted mb-0 small">Exceeding Target</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-3">
                <div class="card border-0 shadow-sm overview-card">
                  <div class="card-body text-center">
                    <div class="avatar-sm mx-auto mb-3">
                      <span class="avatar-title rounded-circle bg-soft-warning text-warning font-size-20">
                        <i class="bx bx-trending-up"></i>
                      </span>
                    </div>
                    <h5 class="mb-1 text-warning">{{ overviewSummary.onTrack }}</h5>
                    <p class="text-muted mb-0 small">On Track (70%+)</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-3">
                <div class="card border-0 shadow-sm overview-card">
                  <div class="card-body text-center">
                    <div class="avatar-sm mx-auto mb-3">
                      <span class="avatar-title rounded-circle bg-soft-danger text-danger font-size-20">
                        <i class="bx bx-trending-down"></i>
                      </span>
                    </div>
                    <h5 class="mb-1 text-danger">{{ overviewSummary.belowTarget }}</h5>
                    <p class="text-muted mb-0 small">Below Target</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Overall Progress Bar -->
            <div class="row mb-4" v-if="overviewSummary">
              <div class="col-12">
                <div class="card border-0 shadow-sm">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h6 class="mb-0">Overall Achievement</h6>
                      <span class="fw-bold" :class="getPercentageClass(overviewSummary.overallPercentage)">
                        {{ overviewSummary.overallPercentage }}%
                      </span>
                    </div>
                    <div class="progress" style="height: 12px; border-radius: 6px;">
                      <div class="progress-bar" role="progressbar"
                           :style="{ width: Math.min(overviewSummary.overallPercentage, 100) + '%' }"
                           :class="getProgressBarClass(overviewSummary.overallPercentage)">
                      </div>
                    </div>
                    <div class="d-flex justify-content-between mt-2">
                      <small class="text-muted">Target: {{ formatPrice(overviewSummary.totalTarget) }}</small>
                      <small class="text-muted">Collected: {{ formatPrice(overviewSummary.totalActual) }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Collectors Table -->
            <div class="row">
              <div class="col-12">
                <div class="card border-0 shadow-sm">
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                      <h6 class="mb-0"><i class="bx bx-table me-2"></i>Collector Target Performance</h6>
                      <div class="d-flex gap-2 flex-wrap">
                        <input v-model="overviewSearch" type="text" class="form-control form-control-sm" placeholder="Search collector..." style="width: 200px;">
                        <select v-model="overviewStatusFilter" class="form-select form-select-sm" style="width: 150px;">
                          <option value="">All Status</option>
                          <option value="exceeding">Exceeding</option>
                          <option value="on-track">On Track</option>
                          <option value="warning">Warning</option>
                          <option value="critical">Critical</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <!-- Batch Loading Progress Bar -->
                    <div v-if="batchLoading" class="px-3 pt-3 pb-2">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <div>
                          <span class="fw-semibold text-primary">
                            <i class="bx bx-loader-alt bx-spin me-1"></i>
                            Loading collectors... {{ batchLoaded }} / {{ batchTotal || '?' }}
                          </span>
                        </div>
                        <div class="d-flex align-items-center gap-3">
                          <small class="text-muted">{{ batchETA }}</small>
                          <button class="btn btn-sm btn-outline-danger" @click="cancelBatchLoad" title="Stop loading">
                            <i class="bx bx-stop me-1"></i>Stop
                          </button>
                        </div>
                      </div>
                      <div class="progress" style="height: 8px; border-radius: 4px;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                             role="progressbar"
                             :style="{ width: (batchTotal > 0 ? Math.round((batchLoaded / batchTotal) * 100) : 0) + '%' }">
                        </div>
                      </div>
                      <div class="d-flex justify-content-between mt-1">
                        <small class="text-muted">{{ batchTotal > 0 ? Math.round((batchLoaded / batchTotal) * 100) : 0 }}% complete</small>
                        <small class="text-muted">{{ overviewData.length }} records loaded</small>
                      </div>
                    </div>
                    <!-- Initial Loading (first batch) -->
                    <div v-if="loading && overviewData.length === 0" class="text-center py-5">
                      <div class="spinner-border text-primary mb-3" role="status"></div>
                      <p class="text-muted">Loading first batch...</p>
                    </div>
                    <div v-else-if="!loading && !batchLoading && filteredOverviewData.length === 0" class="text-center py-5">
                      <i class="bx bx-search-alt text-muted" style="font-size: 3rem;"></i>
                      <p class="text-muted mt-2">No collectors found</p>
                    </div>
                    <div v-if="filteredOverviewData.length > 0" class="table-responsive">
                      <table class="table table-hover table-striped mb-0">
                        <thead class="table-light">
                        <tr>
                          <th style="width: 50px;">#</th>
                          <th>Collector</th>
                          <th>Sub County</th>
                          <th>Ward</th>
                          <th>Zone</th>
                          <th class="text-end">Target</th>
                          <th class="text-end">Collected</th>
                          <th class="text-center" style="width: 160px;">Progress</th>
                          <th class="text-center">%</th>
                          <th class="text-end">Variance</th>
                          <th class="text-center">Txns</th>
                          <th class="text-center">Status</th>
                          <th class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item) in paginatedOverviewData" :key="item.collectorID">
                          <td>
                              <span v-if="item.rank <= 3" class="badge" :class="{
                                'bg-warning': item.rank === 1,
                                'bg-secondary': item.rank === 2,
                                'bg-bronze': item.rank === 3
                              }">{{ item.rank }}</span>
                            <span v-else class="text-muted">{{ item.rank }}</span>
                          </td>
                          <td>
                            <div class="fw-semibold">{{ item.collectorName }}</div>
                            <small class="text-muted">ID: {{ item.collectorID }} | {{ item.collectorPhone }}</small>
                          </td>
                          <td>
                            <span class="badge bg-soft-primary text-primary">{{ item.subCountyName || '—' }}</span>
                          </td>
                          <td>
                            <small class="text-muted">{{ item.wardName || '—' }}</small>
                          </td>
                          <td>
                            <small class="text-muted">{{ item.zone || '—' }}</small>
                          </td>
                          <td class="text-end">{{ formatPrice(item.target) }}</td>
                          <td class="text-end fw-semibold">{{ formatPrice(item.actual) }}</td>
                          <td>
                            <div class="progress" style="height: 8px; border-radius: 4px;">
                              <div class="progress-bar" role="progressbar"
                                   :style="{ width: Math.min(item.percentage, 100) + '%' }"
                                   :class="getProgressBarClass(item.percentage)">
                              </div>
                            </div>
                          </td>
                          <td class="text-center">
                              <span class="fw-bold" :class="getPercentageClass(item.percentage)">
                                {{ item.percentage }}%
                              </span>
                          </td>
                          <td class="text-end" :class="item.variance >= 0 ? 'text-success' : 'text-danger'">
                            {{ item.variance >= 0 ? '+' : '' }}{{ formatPrice(item.variance) }}
                          </td>
                          <td class="text-center">{{ numberFormat(item.transactionCount) }}</td>
                          <td class="text-center">
                              <span class="badge" :class="getStatusBadge(item.status)">
                                {{ getStatusLabel(item.status) }}
                              </span>
                          </td>
                          <td class="text-center">
                            <button class="btn btn-sm btn-outline-primary" @click="viewCollector(item.collectorID)" title="View Details">
                              <i class="bx bx-show"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- Pagination -->
                    <div v-if="filteredOverviewData.length > overviewPerPage" class="card-footer bg-white d-flex justify-content-between align-items-center">
                      <small class="text-muted">Showing {{ ((overviewPage - 1) * overviewPerPage) + 1 }}-{{ Math.min(overviewPage * overviewPerPage, filteredOverviewData.length) }} of {{ filteredOverviewData.length }}</small>
                      <nav>
                        <ul class="pagination pagination-sm mb-0">
                          <li class="page-item" :class="{ disabled: overviewPage === 1 }">
                            <a class="page-link" href="javascript:void(0);" @click="overviewPage--">Prev</a>
                          </li>
                          <li class="page-item" v-for="p in overviewTotalPages" :key="p" :class="{ active: p === overviewPage }">
                            <a class="page-link" href="javascript:void(0);" @click="overviewPage = p">{{ p }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: overviewPage === overviewTotalPages }">
                            <a class="page-link" href="javascript:void(0);" @click="overviewPage++">Next</a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ============================= -->
          <!-- TAB 2: INDIVIDUAL DASHBOARD   -->
          <!-- ============================= -->
          <div v-if="activeTab === 'individual'">

            <!-- Collector Search -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card border-0 shadow-sm">
                  <div class="card-body">
                    <div class="row g-3 align-items-end">
                      <div class="col-md-5">
                        <label class="form-label fw-semibold">
                          <i class="bx bx-search text-primary me-1"></i> Search Collector
                        </label>
                        <input v-model="individualSearch" type="text" class="form-control form-control-lg"
                               placeholder="Type collector name or ID number..."
                               @input="searchCollectors">
                      </div>
                      <div class="col-md-3">
                        <label class="form-label fw-semibold">
                          <i class="bx bx-calendar text-primary me-1"></i> Date Range
                        </label>
                        <div class="input-group">
                          <input v-model="dateFrom" type="date" class="form-control">
                          <span class="input-group-text bg-light">to</span>
                          <input v-model="dateTo" type="date" class="form-control">
                        </div>
                      </div>
                      <div class="col-md-4 d-flex gap-2">
                        <button @click="loadIndividualCollector" class="btn btn-primary btn-lg flex-fill" :disabled="!selectedCollectorID || individualLoading">
                          <i v-if="individualLoading" class="bx bx-loader-alt bx-spin me-1"></i>
                          <i v-else class="bx bx-user-check me-1"></i>
                          Load Dashboard
                        </button>
                        <button @click="exportCurrentTab" class="btn btn-success btn-lg" :disabled="!individualData || individualLoading" title="Export CSV">
                          <i class="bx bxs-download"></i>
                        </button>
                      </div>
                    </div>

                    <!-- Search Results Dropdown -->
                    <div v-if="collectorSearchResults.length > 0 && showSearchResults" class="mt-2">
                      <div class="list-group shadow-sm" style="max-height: 250px; overflow-y: auto;">
                        <a v-for="c in collectorSearchResults" :key="c.collectorID"
                           class="list-group-item list-group-item-action"
                           href="javascript:void(0);"
                           @click="selectCollector(c)">
                          <div class="d-flex justify-content-between align-items-start">
                            <div>
                              <span class="fw-semibold">{{ c.collectorName }}</span>
                              <small class="text-muted ms-2">ID: {{ c.collectorID }} | {{ c.collectorPhone }}</small>
                              <!-- Location badges in search results -->
                              <div class="mt-1">
                                <span v-if="c.subCountyName" class="badge bg-soft-primary text-primary me-1">{{ c.subCountyName }}</span>
                                <span v-if="c.wardName" class="badge bg-soft-info text-info me-1">{{ c.wardName }}</span>
                                <span v-if="c.zone" class="badge bg-soft-secondary text-secondary">{{ c.zone }}</span>
                              </div>
                            </div>
                            <span class="badge bg-light text-dark">Monthly: {{ formatPrice(c.monthlyTargets) }}</span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Individual Dashboard Content -->
            <div v-if="individualData && individualData.collector">

              <!-- Collector Info Bar -->
              <div class="row mb-4">
                <div class="col-12">
                  <div class="card border-0 shadow-sm bg-gradient-primary text-white">
                    <div class="card-body py-3">
                      <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
                        <div>
                          <h5 class="mb-1 text-white">
                            <i class="bx bx-user-circle me-2"></i>
                            {{ individualData.collector.collectorName }}
                          </h5>
                          <small class="opacity-75">
                            ID: {{ individualData.collector.collectorID }} |
                            Phone: {{ individualData.collector.collectorPhone }} |
                            Email: {{ individualData.collector.collectorEmail || 'N/A' }}
                          </small>
                          <!-- Location row -->
                          <div class="mt-2 d-flex flex-wrap gap-2">
                            <span v-if="individualData.collector.subCountyName" class="badge bg-white bg-opacity-25 text-white px-2 py-1">
                              <i class="bx bx-map me-1"></i>{{ individualData.collector.subCountyName }}
                            </span>
                            <span v-if="individualData.collector.wardName" class="badge bg-white bg-opacity-25 text-white px-2 py-1">
                              <i class="bx bx-building me-1"></i>{{ individualData.collector.wardName }}
                            </span>
                            <span v-if="individualData.collector.zone" class="badge bg-white bg-opacity-25 text-white px-2 py-1">
                              <i class="bx bx-sitemap me-1"></i>{{ individualData.collector.zone }}
                            </span>
                          </div>
                        </div>
                        <span class="badge bg-white text-primary px-3 py-2">
                          {{ individualData.collector.status }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Target Progress Cards -->
              <div class="row mb-4">
                <div class="col-md-4" v-for="(period, key) in (individualData.performance || {})" :key="key">
                  <div class="card border-0 shadow-sm h-100">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-start mb-3">
                        <div>
                          <h6 class="text-muted text-uppercase mb-1" style="font-size: 0.75rem;">{{ getPeriodLabel(key) }}</h6>
                          <h4 class="mb-0">{{ formatPrice(period.actual) }}</h4>
                        </div>
                        <span class="badge rounded-pill px-3 py-2" :class="getPercentageBadge(period.percentage)">
                          {{ period.percentage }}%
                        </span>
                      </div>
                      <div class="progress mb-2" style="height: 10px; border-radius: 5px;">
                        <div class="progress-bar" role="progressbar"
                             :style="{ width: Math.min(period.percentage, 100) + '%' }"
                             :class="getProgressBarClass(period.percentage)">
                        </div>
                      </div>
                      <div class="d-flex justify-content-between">
                        <small class="text-muted">Target: {{ formatPrice(period.target) }}</small>
                        <small :class="period.variance >= 0 ? 'text-success' : 'text-danger'">
                          {{ period.variance >= 0 ? '+' : '' }}{{ formatPrice(period.variance) }}
                        </small>
                      </div>
                      <small class="text-muted d-block mt-1">{{ period.transactions }} transactions</small>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Daily Collection Chart & Stream Breakdown -->
              <div class="row mb-4">
                <div class="col-lg-8">
                  <div class="card border-0 shadow-sm h-100">
                    <div class="card-header bg-white border-bottom">
                      <h6 class="mb-0"><i class="bx bx-line-chart text-primary me-2"></i>Daily Collections Trend</h6>
                    </div>
                    <div class="card-body">
                      <div v-if="!individualData.dailyCollections || individualData.dailyCollections.length === 0" class="text-center py-4 text-muted">
                        <i class="bx bx-bar-chart" style="font-size: 2rem;"></i>
                        <p class="mt-2">No collections data for this period</p>
                      </div>
                      <div v-else>
                        <div class="daily-chart-container">
                          <div v-for="(day, idx) in (individualData.dailyCollections || [])" :key="idx"
                               class="daily-bar-wrapper" :title="day.collectionDate + ': ' + formatPrice(day.totalAmount)">
                            <div class="daily-bar"
                                 :style="{ height: getBarHeight(day.totalAmount) + '%' }"
                                 :class="getBarColor(day.totalAmount)">
                            </div>
                            <small class="daily-label">{{ formatShortDate(day.collectionDate) }}</small>
                          </div>
                        </div>
                        <div class="text-center mt-2">
                          <small class="text-muted">
                            Daily Target: {{ formatPrice(individualData.collector.dailyTargets) }}
                            (shown as baseline)
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card border-0 shadow-sm h-100">
                    <div class="card-header bg-white border-bottom">
                      <h6 class="mb-0"><i class="bx bx-pie-chart text-primary me-2"></i>Revenue Streams</h6>
                    </div>
                    <div class="card-body p-0">
                      <div v-if="!individualData.streamBreakdown || individualData.streamBreakdown.length === 0" class="text-center py-4 text-muted">
                        <p>No stream data available</p>
                      </div>
                      <div v-else class="list-group list-group-flush">
                        <div v-for="(stream, idx) in (individualData.streamBreakdown || [])" :key="idx"
                             class="list-group-item d-flex justify-content-between align-items-center py-3">
                          <div>
                            <span class="fw-semibold">{{ stream.stream || 'Unknown' }}</span>
                            <br><small class="text-muted">{{ stream.transactionCount }} txns</small>
                          </div>
                          <span class="fw-bold text-primary">{{ formatPrice(stream.totalAmount) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Recent Transactions -->
              <div class="row">
                <div class="col-12">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-white border-bottom">
                      <h6 class="mb-0"><i class="bx bx-receipt text-primary me-2"></i>Recent Transactions</h6>
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table table-hover table-sm mb-0">
                          <thead class="table-light">
                          <tr>
                            <th>Date</th>
                            <th>Transaction Code</th>
                            <th>Stream</th>
                            <th>Payment</th>
                            <th class="text-end">Amount</th>
                            <th>Sub County</th>
                            <th>Ward</th>
                            <th>Zone</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="txn in (individualData.recentTransactions || [])" :key="txn.id">
                            <td><small>{{ formatDateTime(txn.date) }}</small></td>
                            <td><span class="badge bg-light text-dark">{{ txn.transaction_code }}</span></td>
                            <td><span class="badge bg-info">{{ txn.stream }}</span></td>
                            <td>{{ txn.paymentType }}</td>
                            <td class="text-end fw-semibold">{{ formatPrice(txn.amount) }}</td>
                            <td><small class="text-muted">{{ txn.subCountyName || '—' }}</small></td>
                            <td><small class="text-muted">{{ txn.wardName || '—' }}</small></td>
                            <td><small class="text-muted">{{ txn.zone || '—' }}</small></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div v-else-if="!individualLoading && !individualData" class="text-center py-5">
              <i class="bx bx-user-plus text-muted" style="font-size: 4rem;"></i>
              <h5 class="text-muted mt-3">Select a Collector</h5>
              <p class="text-muted">Search for a collector above to view their performance dashboard</p>
            </div>
          </div>

          <!-- ============================= -->
          <!-- TAB 3: TOP/BOTTOM PERFORMERS  -->
          <!-- ============================= -->
          <div v-if="activeTab === 'performers'">

            <div v-if="performersLoading" class="text-center py-5">
              <div class="spinner-border text-primary mb-3" role="status"></div>
              <p class="text-muted">Loading performers data...</p>
            </div>

            <div v-else-if="performersData">
              <div class="row">
                <!-- Top Performers -->
                <div class="col-lg-6 mb-4">
                  <div class="card border-0 shadow-sm h-100">
                    <div class="card-header bg-success text-white border-0">
                      <h6 class="mb-0 text-white">
                        <i class="bx bx-trophy me-2"></i>
                        Top {{ performersData.topPerformers.length }} Performers
                      </h6>
                    </div>
                    <div class="card-body p-0">
                      <div v-for="(item, idx) in performersData.topPerformers" :key="'top-' + idx"
                           class="performer-item d-flex align-items-center p-3 border-bottom">
                        <div class="rank-badge me-3" :class="getRankBadgeClass(item.rank)">
                          {{ item.rank }}
                        </div>
                        <div class="flex-grow-1">
                          <div class="d-flex justify-content-between align-items-start">
                            <div>
                              <h6 class="mb-0">{{ item.collectorName }}</h6>
                              <!-- Location info -->
                              <div class="mt-1">
                                <small class="text-muted">
                                  <i class="bx bx-map-pin me-1"></i>
                                  {{ [item.subCountyName, item.wardName, item.zone].filter(Boolean).join(' · ') || 'No location' }}
                                </small>
                              </div>
                              <small class="text-muted">{{ item.transactionCount }} transactions</small>
                            </div>
                            <div class="text-end">
                              <span class="fw-bold text-success">{{ item.percentage }}%</span>
                              <br><small class="text-muted">{{ formatPrice(item.totalCollected) }}</small>
                            </div>
                          </div>
                          <div class="progress mt-2" style="height: 5px; border-radius: 3px;">
                            <div class="progress-bar bg-success" role="progressbar"
                                 :style="{ width: Math.min(item.percentage, 100) + '%' }">
                            </div>
                          </div>
                        </div>
                        <button class="btn btn-sm btn-outline-primary ms-2" @click="viewCollector(item.collectorID)" title="View">
                          <i class="bx bx-show"></i>
                        </button>
                      </div>
                      <div v-if="performersData.topPerformers.length === 0" class="text-center py-4 text-muted">
                        No data available
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Bottom Performers -->
                <div class="col-lg-6 mb-4">
                  <div class="card border-0 shadow-sm h-100">
                    <div class="card-header bg-danger text-white border-0">
                      <h6 class="mb-0 text-white">
                        <i class="bx bx-error-circle me-2"></i>
                        Bottom {{ performersData.bottomPerformers.length }} Performers
                      </h6>
                    </div>
                    <div class="card-body p-0">
                      <div v-for="(item, idx) in performersData.bottomPerformers" :key="'bottom-' + idx"
                           class="performer-item d-flex align-items-center p-3 border-bottom">
                        <div class="rank-badge me-3 bg-danger text-white">
                          {{ item.rank }}
                        </div>
                        <div class="flex-grow-1">
                          <div class="d-flex justify-content-between align-items-start">
                            <div>
                              <h6 class="mb-0">{{ item.collectorName }}</h6>
                              <!-- Location info -->
                              <div class="mt-1">
                                <small class="text-muted">
                                  <i class="bx bx-map-pin me-1"></i>
                                  {{ [item.subCountyName, item.wardName, item.zone].filter(Boolean).join(' · ') || 'No location' }}
                                </small>
                              </div>
                              <small class="text-muted">{{ item.transactionCount }} transactions</small>
                            </div>
                            <div class="text-end">
                              <span class="fw-bold text-danger">{{ item.percentage }}%</span>
                              <br><small class="text-muted">{{ formatPrice(item.totalCollected) }}</small>
                            </div>
                          </div>
                          <div class="progress mt-2" style="height: 5px; border-radius: 3px;">
                            <div class="progress-bar bg-danger" role="progressbar"
                                 :style="{ width: Math.min(item.percentage, 100) + '%' }">
                            </div>
                          </div>
                        </div>
                        <button class="btn btn-sm btn-outline-primary ms-2" @click="viewCollector(item.collectorID)" title="View">
                          <i class="bx bx-show"></i>
                        </button>
                      </div>
                      <div v-if="performersData.bottomPerformers.length === 0" class="text-center py-4 text-muted">
                        No data available
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Zero Collection Collectors -->
              <div class="row" v-if="performersData.zeroCollectors && performersData.zeroCollectors.length > 0">
                <div class="col-12">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-dark text-white border-0">
                      <h6 class="mb-0 text-white">
                        <i class="bx bx-block me-2"></i>
                        Zero Collections ({{ performersData.zeroCollectors.length }} collectors)
                      </h6>
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table table-hover table-sm mb-0">
                          <thead class="table-light">
                          <tr>
                            <th>#</th>
                            <th>Collector</th>
                            <th>Phone</th>
                            <th>Sub County</th>
                            <th>Ward</th>
                            <th>Zone</th>
                            <th class="text-end">Target</th>
                            <th class="text-center">Status</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, idx) in performersData.zeroCollectors" :key="'zero-' + idx">
                            <td>{{ idx + 1 }}</td>
                            <td class="fw-semibold">{{ item.collectorName }}</td>
                            <td>{{ item.collectorPhone }}</td>
                            <td><span class="badge bg-soft-primary text-primary">{{ item.subCountyName || '—' }}</span></td>
                            <td><small class="text-muted">{{ item.wardName || '—' }}</small></td>
                            <td><small class="text-muted">{{ item.zone || '—' }}</small></td>
                            <td class="text-end">{{ formatPrice(item.target) }}</td>
                            <td class="text-center"><span class="badge bg-dark">No Collections</span></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ============================= -->
          <!-- TAB 4: ALERTS & COMPARISON    -->
          <!-- ============================= -->
          <div v-if="activeTab === 'alerts'">

            <div v-if="alertsLoading" class="text-center py-5">
              <div class="spinner-border text-primary mb-3" role="status"></div>
              <p class="text-muted">Loading alerts data...</p>
            </div>

            <div v-else-if="alertsData">

              <!-- Alert Summary Cards -->
              <div class="row mb-4">
                <div class="col-md-4">
                  <div class="card border-0 shadow-sm border-start border-danger border-4">
                    <div class="card-body d-flex align-items-center">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-sm">
                          <span class="avatar-title rounded-circle bg-soft-danger text-danger font-size-20">
                            <i class="bx bx-x-circle"></i>
                          </span>
                        </div>
                      </div>
                      <div>
                        <h4 class="mb-0">{{ alertsData.alertSummary.totalZero }}</h4>
                        <p class="text-muted mb-0 small">Zero Collections</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card border-0 shadow-sm border-start border-warning border-4">
                    <div class="card-body d-flex align-items-center">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-sm">
                          <span class="avatar-title rounded-circle bg-soft-warning text-warning font-size-20">
                            <i class="bx bx-error"></i>
                          </span>
                        </div>
                      </div>
                      <div>
                        <h4 class="mb-0">{{ alertsData.alertSummary.totalBelowTarget }}</h4>
                        <p class="text-muted mb-0 small">Below 50% Target</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card border-0 shadow-sm border-start border-info border-4">
                    <div class="card-body d-flex align-items-center">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-sm">
                          <span class="avatar-title rounded-circle bg-soft-info text-info font-size-20">
                            <i class="bx bx-time-five"></i>
                          </span>
                        </div>
                      </div>
                      <div>
                        <h4 class="mb-0">{{ alertsData.alertSummary.totalInactive }}</h4>
                        <p class="text-muted mb-0 small">Inactive (3+ Days)</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Alert Lists -->
              <div class="row mb-4">
                <div class="col-12">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-white border-bottom">
                      <ul class="nav nav-tabs card-header-tabs">
                        <li class="nav-item">
                          <a class="nav-link" :class="{ active: alertSubTab === 'zero' }" href="javascript:void(0);" @click="alertSubTab = 'zero'">
                            <i class="bx bx-x-circle text-danger me-1"></i> Zero Collections
                            <span class="badge bg-danger ms-1">{{ alertsData.alerts.zeroCollections.length }}</span>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" :class="{ active: alertSubTab === 'below' }" href="javascript:void(0);" @click="alertSubTab = 'below'">
                            <i class="bx bx-error text-warning me-1"></i> Below Target
                            <span class="badge bg-warning ms-1">{{ alertsData.alerts.belowTarget.length }}</span>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" :class="{ active: alertSubTab === 'inactive' }" href="javascript:void(0);" @click="alertSubTab = 'inactive'">
                            <i class="bx bx-time-five text-info me-1"></i> Inactive
                            <span class="badge bg-info ms-1">{{ alertsData.alerts.inactive.length }}</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table table-hover mb-0">
                          <thead class="table-light">
                          <tr>
                            <th>#</th>
                            <th>Collector</th>
                            <th>Phone</th>
                            <th>Sub County</th>
                            <th>Ward</th>
                            <th>Zone</th>
                            <th class="text-end">Target</th>
                            <th v-if="alertSubTab === 'below'" class="text-end">Collected</th>
                            <th v-if="alertSubTab === 'below'" class="text-center">%</th>
                            <th>Alert</th>
                            <th class="text-center">Severity</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, idx) in currentAlertList" :key="idx">
                            <td>{{ idx + 1 }}</td>
                            <td class="fw-semibold">{{ item.collectorName }}</td>
                            <td>{{ item.collectorPhone }}</td>
                            <td><span class="badge bg-soft-primary text-primary">{{ item.subCountyName || '—' }}</span></td>
                            <td><small class="text-muted">{{ item.wardName || '—' }}</small></td>
                            <td><small class="text-muted">{{ item.zone || '—' }}</small></td>
                            <td class="text-end">{{ formatPrice(item.target) }}</td>
                            <td v-if="alertSubTab === 'below'" class="text-end">{{ formatPrice(item.totalCollected) }}</td>
                            <td v-if="alertSubTab === 'below'" class="text-center">
                              <span class="fw-bold text-danger">{{ item.percentage }}%</span>
                            </td>
                            <td><small>{{ item.alertMessage }}</small></td>
                            <td class="text-center">
                                <span class="badge" :class="{
                                  'bg-danger': item.severity === 'critical',
                                  'bg-warning': item.severity === 'warning',
                                  'bg-info': item.severity === 'info'
                                }">{{ item.severity }}</span>
                            </td>
                          </tr>
                          <tr v-if="currentAlertList.length === 0">
                            <td colspan="11" class="text-center py-4 text-muted">
                              No alerts in this category
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Sub County Comparison -->
              <div class="row" v-if="alertsData.subCountyComparison && alertsData.subCountyComparison.length > 0">
                <div class="col-12">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-white border-bottom">
                      <h6 class="mb-0"><i class="bx bx-bar-chart-alt-2 text-primary me-2"></i>Sub County Comparison</h6>
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table table-hover mb-0">
                          <thead class="table-light">
                          <tr>
                            <th>#</th>
                            <th>Sub County</th>
                            <th class="text-center">Collectors</th>
                            <th class="text-center">Transactions</th>
                            <th class="text-end">Total Collected</th>
                            <th class="text-end">Avg Transaction</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(sc, idx) in alertsData.subCountyComparison" :key="idx">
                            <td>{{ idx + 1 }}</td>
                            <td class="fw-semibold">{{ sc.subCountyName }}</td>
                            <td class="text-center">{{ sc.collectorCount }}</td>
                            <td class="text-center">{{ numberFormat(sc.transactionCount) }}</td>
                            <td class="text-end fw-bold text-primary">{{ formatPrice(sc.totalCollected) }}</td>
                            <td class="text-end">{{ formatPrice(sc.avgTransaction) }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">© {{ new Date().getFullYear() }} County Revenue System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">Powered by County IT Department</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  </body>
</template>

<script>
/* eslint-disable */
import { biller, execute, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import moment from "moment";

export default {
  name: "CollectorTargetTracking",
  components: {
    NavigationBar
  },
  data() {
    return {
      loading: false,
      showFilters: true,
      activeTab: 'overview',

      // Filters
      periodType: 'daily',
      dateFrom: moment().format('YYYY-MM-DD'),
      dateTo: moment().format('YYYY-MM-DD'),
      selectedSubCounty: '',
      subCounties: [],

      // Tab 1: Overview
      overviewData: [],
      overviewSummary: null,
      overviewSearch: '',
      overviewStatusFilter: '',
      overviewPage: 1,
      overviewPerPage: 25,
      // Batch loading
      batchLoading: false,
      batchTotal: 0,
      batchLoaded: 0,
      batchStartTime: null,
      batchETA: '',
      batchCancelled: false,

      // Tab 2: Individual
      individualSearch: '',
      selectedCollectorID: null,
      collectorSearchResults: [],
      showSearchResults: false,
      individualLoading: false,
      individualData: null,
      searchTimeout: null,

      // Tab 3: Performers
      performersLoading: false,
      performersData: null,

      // Tab 4: Alerts
      alertsLoading: false,
      alertsData: null,
      alertSubTab: 'zero',
      alertCount: 0
    };
  },

  computed: {
    filteredOverviewData() {
      let data = this.overviewData;

      if (this.overviewSearch) {
        const search = this.overviewSearch.toLowerCase();
        data = data.filter(item =>
            (item.collectorName || '').toLowerCase().includes(search) ||
            (item.collectorID || '').toString().includes(search) ||
            (item.collectorPhone || '').includes(search) ||
            (item.subCountyName || '').toLowerCase().includes(search) ||
            (item.wardName || '').toLowerCase().includes(search) ||
            (item.zone || '').toLowerCase().includes(search)
        );
      }

      if (this.overviewStatusFilter) {
        data = data.filter(item => item.status === this.overviewStatusFilter);
      }

      return data;
    },

    paginatedOverviewData() {
      const start = (this.overviewPage - 1) * this.overviewPerPage;
      return this.filteredOverviewData.slice(start, start + this.overviewPerPage);
    },

    overviewTotalPages() {
      return Math.ceil(this.filteredOverviewData.length / this.overviewPerPage);
    },

    currentAlertList() {
      if (!this.alertsData) return [];
      const map = {
        zero: this.alertsData.alerts.zeroCollections,
        below: this.alertsData.alerts.belowTarget,
        inactive: this.alertsData.alerts.inactive
      };
      return map[this.alertSubTab] || [];
    }
  },

  watch: {
    periodType(val) {
      if (val === 'daily') {
        this.dateFrom = moment().format('YYYY-MM-DD');
        this.dateTo = moment().format('YYYY-MM-DD');
      } else if (val === 'monthly') {
        this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
        this.dateTo = moment().format('YYYY-MM-DD');
      } else if (val === 'financialYear') {
        const m = moment().month();
        if (m >= 6) {
          this.dateFrom = moment().startOf('year').month(6).format('YYYY-MM-DD');
          this.dateTo = moment().format('YYYY-MM-DD');
        } else {
          this.dateFrom = moment().subtract(1, 'year').month(6).startOf('month').format('YYYY-MM-DD');
          this.dateTo = moment().format('YYYY-MM-DD');
        }
      }
      this.loadTabData();
    },
    selectedSubCounty() {
      this.loadTabData();
    }
  },

  mounted() {
    this.loadSubCounties();
    this.menuAccess();
    this.$nextTick(() => {
      this.loadOverviewData();
      this.loadAlertCount();
    });
  },

  methods: {
    getRight(type) {
      return getRight(type);
    },

    formatPrice(value) {
      const num = parseFloat(value) || 0;
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(num);
    },

    formatDateDisplay(dateStr) {
      return moment(dateStr).format('DD MMM YYYY');
    },

    formatDateTime(dateStr) {
      return moment(dateStr).format('DD/MM/YYYY HH:mm');
    },

    formatShortDate(dateStr) {
      return moment(dateStr).format('DD/MM');
    },

    numberFormat(num) {
      if (!num) return '0';
      return new Intl.NumberFormat("en-GB").format(num);
    },

    gotTo(route) {
      this.$router.push(route);
    },

    toggleFilters() {
      this.showFilters = !this.showFilters;
    },

    // ---- Status & Styling Helpers ----

    getPercentageClass(pct) {
      if (pct >= 100) return 'text-success';
      if (pct >= 70) return 'text-warning';
      return 'text-danger';
    },

    getProgressBarClass(pct) {
      if (pct >= 100) return 'bg-success';
      if (pct >= 70) return 'bg-warning';
      if (pct >= 50) return 'bg-orange';
      return 'bg-danger';
    },

    getPercentageBadge(pct) {
      if (pct >= 100) return 'bg-success';
      if (pct >= 70) return 'bg-warning text-dark';
      return 'bg-danger';
    },

    getStatusBadge(status) {
      const map = {
        'exceeding': 'bg-success',
        'on-track': 'bg-warning text-dark',
        'warning': 'bg-orange text-white',
        'critical': 'bg-danger'
      };
      return map[status] || 'bg-secondary';
    },

    getStatusLabel(status) {
      const map = {
        'exceeding': 'Exceeding',
        'on-track': 'On Track',
        'warning': 'Warning',
        'critical': 'Critical'
      };
      return map[status] || status;
    },

    getRankBadgeClass(rank) {
      if (rank === 1) return 'bg-gold';
      if (rank === 2) return 'bg-silver';
      if (rank === 3) return 'bg-bronze-badge';
      return 'bg-light text-dark';
    },

    getPeriodLabel(key) {
      const map = {
        daily: 'Today\'s Performance',
        monthly: 'Monthly Performance',
        financialYear: 'Financial Year Performance'
      };
      return map[key] || key;
    },

    getBarHeight(amount) {
      if (!this.individualData || !this.individualData.dailyCollections || !this.individualData.dailyCollections.length) return 0;
      const max = Math.max(...this.individualData.dailyCollections.map(d => parseFloat(d.totalAmount) || 0));
      return max > 0 ? Math.max(((parseFloat(amount) || 0) / max) * 100, 3) : 0;
    },

    getBarColor(amount) {
      if (!this.individualData || !this.individualData.collector) return '';
      const dailyTarget = parseFloat(this.individualData.collector.dailyTargets) || 0;
      const val = parseFloat(amount) || 0;
      if (dailyTarget <= 0) return 'bar-primary';
      if (val >= dailyTarget) return 'bar-success';
      if (val >= dailyTarget * 0.7) return 'bar-warning';
      return 'bar-danger';
    },

    // ---- Tab Switching ----

    switchTab(tab) {
      this.activeTab = tab;
      if (tab === 'overview' && this.overviewData.length === 0) {
        this.loadOverviewData();
      } else if (tab === 'performers' && !this.performersData) {
        this.loadPerformersData();
      } else if (tab === 'alerts' && !this.alertsData) {
        this.loadAlertsData();
      }
    },

    loadTabData() {
      if (this.activeTab === 'overview') this.loadOverviewData();
      else if (this.activeTab === 'performers') this.loadPerformersData();
      else if (this.activeTab === 'alerts') this.loadAlertsData();
    },

    // ---- API Calls ----

    async loadSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCounty");
        const res = await execute(data, biller);
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties || [];
        }
      } catch (e) {
        console.error('Error loading sub-counties:', e);
      }
    },

    async loadOverviewData() {
      this.batchCancelled = true;
      await this.$nextTick();
      this.batchCancelled = false;

      this.loading = true;
      this.batchLoading = true;
      this.overviewData = [];
      this.overviewSummary = null;
      this.overviewPage = 1;
      this.batchLoaded = 0;
      this.batchTotal = 0;
      this.batchETA = 'Calculating...';
      this.batchStartTime = Date.now();

      const batchSize = this.periodType === 'financialYear' ? 10 : 20;
      let offset = 0;
      let hasMore = true;

      try {
        while (hasMore && !this.batchCancelled) {
          const data = new FormData();
          data.append("function", "getCollectorTargetPerformanceBatch");
          data.append("periodType", this.periodType);
          data.append("dateFrom", this.dateFrom);
          data.append("dateTo", this.dateTo);
          data.append("offset", offset.toString());
          data.append("batchSize", batchSize.toString());
          if (this.selectedSubCounty) {
            data.append("subCountyID", this.selectedSubCounty);
          }

          const res = await execute(data, biller);
          if (res.data.success) {
            const batch = res.data.data;

            if (offset === 0 && batch.totalUsers !== undefined) {
              this.batchTotal = batch.totalUsers;
            }

            if (batch.batch && batch.batch.length > 0) {
              this.overviewData = [...this.overviewData, ...batch.batch];
              this.batchLoaded = this.overviewData.length;
            }

            this.calculateETA();
            this.recalculateSummary();

            hasMore = batch.hasMore;
            offset += batchSize;

            if (this.loading) {
              this.loading = false;
            }
          } else {
            console.error('Batch error:', res.data.message);
            hasMore = false;
          }
        }
      } catch (e) {
        console.error('Error loading overview:', e);
      } finally {
        this.loading = false;
        this.batchLoading = false;

        if (this.overviewData.length > 0) {
          this.overviewData.sort((a, b) => b.percentage - a.percentage);
          this.overviewData.forEach((item, idx) => {
            item.rank = idx + 1;
          });
          this.recalculateSummary();
        }
      }
    },

    calculateETA() {
      if (this.batchTotal <= 0 || this.batchLoaded <= 0) return;
      const elapsed = (Date.now() - this.batchStartTime) / 1000;
      const rate = this.batchLoaded / elapsed;
      const remaining = this.batchTotal - this.batchLoaded;
      const etaSeconds = Math.ceil(remaining / rate);

      if (etaSeconds < 60) {
        this.batchETA = etaSeconds + 's remaining';
      } else {
        const mins = Math.floor(etaSeconds / 60);
        const secs = etaSeconds % 60;
        this.batchETA = mins + 'm ' + secs + 's remaining';
      }
    },

    recalculateSummary() {
      let totalTarget = 0;
      let totalActual = 0;
      let exceeding = 0;
      let onTrack = 0;
      let belowTarget = 0;
      let zeroCollection = 0;

      this.overviewData.forEach(item => {
        totalTarget += parseFloat(item.target || 0);
        totalActual += parseFloat(item.actual || 0);
        if (item.status === 'exceeding') exceeding++;
        else if (item.status === 'on-track') onTrack++;
        else belowTarget++;
        if (parseFloat(item.actual || 0) === 0) zeroCollection++;
      });

      this.overviewSummary = {
        totalCollectors: this.batchTotal || this.overviewData.length,
        totalTarget,
        totalActual,
        overallPercentage: totalTarget > 0 ? Math.round((totalActual / totalTarget) * 100 * 100) / 100 : 0,
        exceeding,
        onTrack,
        belowTarget,
        zeroCollection
      };
    },

    cancelBatchLoad() {
      this.batchCancelled = true;
    },

    async searchCollectors() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(async () => {
        if (this.individualSearch.length < 2) {
          this.collectorSearchResults = [];
          this.showSearchResults = false;
          return;
        }

        try {
          const data = new FormData();
          data.append("function", "getActiveCollectors");
          data.append("searchTerm", this.individualSearch);

          const res = await execute(data, biller);
          if (res.data.success) {
            this.collectorSearchResults = res.data.data.collectors || [];
            this.showSearchResults = true;
          }
        } catch (e) {
          console.error('Error searching collectors:', e);
        }
      }, 300);
    },

    selectCollector(collector) {
      this.selectedCollectorID = collector.collectorID;
      this.individualSearch = collector.collectorName;
      this.showSearchResults = false;
      this.collectorSearchResults = [];
    },

    async loadIndividualCollector() {
      if (!this.selectedCollectorID) return;

      this.individualLoading = true;
      this.individualData = null;

      try {
        const data = new FormData();
        data.append("function", "getIndividualCollectorStats");
        data.append("collectorID", this.selectedCollectorID);
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.individualData = res.data.data;
        } else {
          alert(res.data.message || 'Error loading collector data');
        }
      } catch (e) {
        console.error('Error loading individual data:', e);
      } finally {
        this.individualLoading = false;
      }
    },

    viewCollector(collectorID) {
      this.selectedCollectorID = collectorID;
      this.activeTab = 'individual';
      this.loadIndividualCollector();
    },

    async loadPerformersData() {
      this.performersLoading = true;
      this.performersData = null;

      try {
        const data = new FormData();
        data.append("function", "getTopBottomPerformers");
        data.append("periodType", this.periodType);
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("limit", "10");
        if (this.selectedSubCounty) {
          data.append("subCountyID", this.selectedSubCounty);
        }

        const res = await execute(data, biller);
        if (res.data.success) {
          this.performersData = res.data.data;
        }
      } catch (e) {
        console.error('Error loading performers:', e);
      } finally {
        this.performersLoading = false;
      }
    },

    async loadAlertsData() {
      this.alertsLoading = true;
      this.alertsData = null;

      try {
        const data = new FormData();
        data.append("function", "getCollectorAlerts");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        if (this.selectedSubCounty) {
          data.append("subCountyID", this.selectedSubCounty);
        }

        const res = await execute(data, biller);
        if (res.data.success) {
          this.alertsData = res.data.data;
          this.alertCount = this.alertsData.alertSummary.totalAlerts || 0;
        }
      } catch (e) {
        console.error('Error loading alerts:', e);
      } finally {
        this.alertsLoading = false;
      }
    },

    async loadAlertCount() {
      try {
        const data = new FormData();
        data.append("function", "getCollectorAlerts");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.alertCount = res.data.data.alertSummary.totalAlerts || 0;
        }
      } catch (e) {
        // Silently fail
      }
    },

    // ---- Export ----

    exportCurrentTab() {
      try {
        let csvContent = '';
        let fileName = `Collector_Performance_${this.activeTab}_${this.dateFrom}_to_${this.dateTo}.csv`;

        // ---- TAB 1: OVERVIEW ----
        if (this.activeTab === 'overview' && this.overviewData.length > 0) {
          const headers = ['Rank', 'Collector Name', 'ID No', 'Phone', 'Sub County', 'Ward', 'Zone', 'Target', 'Collected', 'Percentage', 'Variance', 'Transactions', 'Status'];
          const rows = this.overviewData.map(item => [
            item.rank,
            this.escapeCSV(item.collectorName),
            item.collectorID,
            item.collectorPhone,
            this.escapeCSV(item.subCountyName || ''),
            this.escapeCSV(item.wardName || ''),
            this.escapeCSV(item.zone || ''),
            parseFloat(item.target || 0).toFixed(2),
            parseFloat(item.actual || 0).toFixed(2),
            item.percentage + '%',
            parseFloat(item.variance || 0).toFixed(2),
            item.transactionCount,
            item.status
          ]);
          csvContent = [headers, ...rows].map(r => r.join(',')).join('\n');
        }

        // ---- TAB 3: TOP/BOTTOM PERFORMERS ----
        else if (this.activeTab === 'performers' && this.performersData) {
          const headers = ['Category', 'Rank', 'Collector Name', 'ID No', 'Phone', 'Sub County', 'Ward', 'Zone', 'Target', 'Collected', 'Percentage', 'Transactions'];
          const rows = [];

          (this.performersData.topPerformers || []).forEach(item => {
            rows.push([
              'Top Performer',
              item.rank,
              this.escapeCSV(item.collectorName),
              item.collectorID,
              item.collectorPhone || '',
              this.escapeCSV(item.subCountyName || ''),
              this.escapeCSV(item.wardName || ''),
              this.escapeCSV(item.zone || ''),
              parseFloat(item.target || 0).toFixed(2),
              parseFloat(item.totalCollected || 0).toFixed(2),
              item.percentage + '%',
              item.transactionCount || 0
            ]);
          });

          (this.performersData.bottomPerformers || []).forEach(item => {
            rows.push([
              'Bottom Performer',
              item.rank,
              this.escapeCSV(item.collectorName),
              item.collectorID,
              item.collectorPhone || '',
              this.escapeCSV(item.subCountyName || ''),
              this.escapeCSV(item.wardName || ''),
              this.escapeCSV(item.zone || ''),
              parseFloat(item.target || 0).toFixed(2),
              parseFloat(item.totalCollected || 0).toFixed(2),
              item.percentage + '%',
              item.transactionCount || 0
            ]);
          });

          (this.performersData.zeroCollectors || []).forEach((item, idx) => {
            rows.push([
              'Zero Collection',
              idx + 1,
              this.escapeCSV(item.collectorName),
              item.collectorID,
              item.collectorPhone || '',
              this.escapeCSV(item.subCountyName || ''),
              this.escapeCSV(item.wardName || ''),
              this.escapeCSV(item.zone || ''),
              parseFloat(item.target || 0).toFixed(2),
              '0.00',
              '0%',
              0
            ]);
          });

          if (rows.length === 0) {
            alert('No data to export');
            return;
          }
          csvContent = [headers, ...rows].map(r => r.join(',')).join('\n');
        }

        // ---- TAB 4: ALERTS & COMPARISON ----
        else if (this.activeTab === 'alerts' && this.alertsData) {
          const headers = ['Alert Type', '#', 'Collector Name', 'ID No', 'Phone', 'Sub County', 'Ward', 'Zone', 'Target', 'Collected', 'Percentage', 'Alert Message', 'Severity'];
          const rows = [];

          (this.alertsData.alerts.zeroCollections || []).forEach((item, idx) => {
            rows.push([
              'Zero Collections',
              idx + 1,
              this.escapeCSV(item.collectorName),
              item.collectorID || '',
              item.collectorPhone || '',
              this.escapeCSV(item.subCountyName || ''),
              this.escapeCSV(item.wardName || ''),
              this.escapeCSV(item.zone || ''),
              parseFloat(item.target || 0).toFixed(2),
              '0.00',
              '0%',
              this.escapeCSV(item.alertMessage || ''),
              item.severity || ''
            ]);
          });

          (this.alertsData.alerts.belowTarget || []).forEach((item, idx) => {
            rows.push([
              'Below Target',
              idx + 1,
              this.escapeCSV(item.collectorName),
              item.collectorID || '',
              item.collectorPhone || '',
              this.escapeCSV(item.subCountyName || ''),
              this.escapeCSV(item.wardName || ''),
              this.escapeCSV(item.zone || ''),
              parseFloat(item.target || 0).toFixed(2),
              parseFloat(item.totalCollected || 0).toFixed(2),
              (item.percentage || 0) + '%',
              this.escapeCSV(item.alertMessage || ''),
              item.severity || ''
            ]);
          });

          (this.alertsData.alerts.inactive || []).forEach((item, idx) => {
            rows.push([
              'Inactive',
              idx + 1,
              this.escapeCSV(item.collectorName),
              item.collectorID || '',
              item.collectorPhone || '',
              this.escapeCSV(item.subCountyName || ''),
              this.escapeCSV(item.wardName || ''),
              this.escapeCSV(item.zone || ''),
              parseFloat(item.target || 0).toFixed(2),
              parseFloat(item.totalCollected || 0).toFixed(2),
              (item.percentage || 0) + '%',
              this.escapeCSV(item.alertMessage || ''),
              item.severity || ''
            ]);
          });

          // Append Sub County Comparison section
          let comparisonCSV = '';
          if (this.alertsData.subCountyComparison && this.alertsData.subCountyComparison.length > 0) {
            const compHeaders = ['#', 'Sub County', 'Collectors', 'Transactions', 'Total Collected', 'Avg Transaction'];
            const compRows = this.alertsData.subCountyComparison.map((sc, idx) => [
              idx + 1,
              this.escapeCSV(sc.subCountyName),
              sc.collectorCount,
              sc.transactionCount,
              parseFloat(sc.totalCollected || 0).toFixed(2),
              parseFloat(sc.avgTransaction || 0).toFixed(2)
            ]);
            comparisonCSV = '\n\nSUB COUNTY COMPARISON\n' + [compHeaders, ...compRows].map(r => r.join(',')).join('\n');
          }

          if (rows.length === 0 && !comparisonCSV) {
            alert('No data to export');
            return;
          }

          csvContent = (rows.length > 0 ? [headers, ...rows].map(r => r.join(',')).join('\n') : '') + comparisonCSV;
        }

        // ---- TAB 2: INDIVIDUAL DASHBOARD ----
        else if (this.activeTab === 'individual' && this.individualData && this.individualData.collector) {
          const c = this.individualData.collector;
          const lines = [];

          lines.push('COLLECTOR INFORMATION');
          lines.push(`Name,${this.escapeCSV(c.collectorName)}`);
          lines.push(`ID,${c.collectorID}`);
          lines.push(`Phone,${c.collectorPhone || ''}`);
          lines.push(`Email,${c.collectorEmail || ''}`);
          lines.push(`Sub County,${this.escapeCSV(c.subCountyName || '')}`);
          lines.push(`Ward,${this.escapeCSV(c.wardName || '')}`);
          lines.push(`Zone,${this.escapeCSV(c.zone || '')}`);
          lines.push(`Status,${this.escapeCSV(c.status || '')}`);
          lines.push('');

          lines.push('PERFORMANCE');
          lines.push(['Period', 'Target', 'Actual', 'Percentage', 'Variance', 'Transactions'].join(','));
          Object.keys(this.individualData.performance || {}).forEach(key => {
            const p = this.individualData.performance[key];
            lines.push([
              this.escapeCSV(this.getPeriodLabel(key)),
              parseFloat(p.target || 0).toFixed(2),
              parseFloat(p.actual || 0).toFixed(2),
              p.percentage + '%',
              parseFloat(p.variance || 0).toFixed(2),
              p.transactions || 0
            ].join(','));
          });
          lines.push('');

          if (this.individualData.streamBreakdown && this.individualData.streamBreakdown.length > 0) {
            lines.push('REVENUE STREAMS');
            lines.push(['Stream', 'Transactions', 'Total Amount'].join(','));
            this.individualData.streamBreakdown.forEach(s => {
              lines.push([
                this.escapeCSV(s.stream || 'Unknown'),
                s.transactionCount || 0,
                parseFloat(s.totalAmount || 0).toFixed(2)
              ].join(','));
            });
            lines.push('');
          }

          if (this.individualData.dailyCollections && this.individualData.dailyCollections.length > 0) {
            lines.push('DAILY COLLECTIONS');
            lines.push(['Date', 'Total Amount'].join(','));
            this.individualData.dailyCollections.forEach(d => {
              lines.push([
                this.escapeCSV(d.collectionDate || ''),
                parseFloat(d.totalAmount || 0).toFixed(2)
              ].join(','));
            });
            lines.push('');
          }

          if (this.individualData.recentTransactions && this.individualData.recentTransactions.length > 0) {
            lines.push('RECENT TRANSACTIONS');
            lines.push(['Date', 'Transaction Code', 'Stream', 'Payment Type', 'Amount', 'Sub County', 'Ward', 'Zone'].join(','));
            this.individualData.recentTransactions.forEach(t => {
              lines.push([
                this.escapeCSV(this.formatDateTime(t.date)),
                this.escapeCSV(t.transaction_code || ''),
                this.escapeCSV(t.stream || ''),
                this.escapeCSV(t.paymentType || ''),
                parseFloat(t.amount || 0).toFixed(2),
                this.escapeCSV(t.subCountyName || ''),
                this.escapeCSV(t.wardName || ''),
                this.escapeCSV(t.zone || '')
              ].join(','));
            });
          }

          csvContent = lines.join('\n');
          fileName = `Collector_${c.collectorID}_${this.dateFrom}_to_${this.dateTo}.csv`;
        }

        // ---- NO DATA ----
        else {
          alert('No data to export. Please load the tab data first.');
          return;
        }

        const metadata = [
          'Collector Performance Target Tracking Report',
          `Tab,${this.activeTab}`,
          `Period Type,${this.periodType}`,
          `Date Range,"${this.dateFrom} to ${this.dateTo}"`,
          `Sub County Filter,"${this.selectedSubCounty ? this.selectedSubCounty : 'All'}"`,
          `Generated,"${moment().format('DD/MM/YYYY HH:mm:ss')}"`,
          '', ''
        ];

        const finalCSV = metadata.join('\n') + '\n' + csvContent;
        const blob = new Blob(['\ufeff' + finalCSV], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert('Export successful!');
      } catch (error) {
        console.error('Export error:', error);
        alert('Error exporting: ' + error.message);
      }
    },

    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Collector Target Tracking");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch(e => console.error("Menu access error:", e.message));
    }
  }
}
</script>

<style scoped>
.nav-pills .nav-link {
  border-radius: 0.5rem;
  color: #495057;
  font-weight: 500;
  transition: all 0.3s ease;
}
.nav-pills .nav-link.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}
.nav-pills .nav-link:hover:not(.active) {
  background-color: #f8f9fa;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.overview-card {
  transition: transform 0.2s ease;
}
.overview-card:hover {
  transform: translateY(-3px);
}

.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.bg-soft-primary { background: rgba(102, 126, 234, 0.15); }
.bg-soft-success { background: rgba(46, 204, 113, 0.15); }
.bg-soft-warning { background: rgba(243, 156, 18, 0.15); }
.bg-soft-danger { background: rgba(231, 76, 60, 0.15); }
.bg-soft-info { background: rgba(52, 152, 219, 0.15); }
.bg-soft-secondary { background: rgba(108, 117, 125, 0.15); }

.bg-orange { background-color: #e67e22; }

.rank-badge {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.85rem;
  flex-shrink: 0;
}
.bg-gold { background: linear-gradient(135deg, #f7dc6f, #f39c12); color: #fff; }
.bg-silver { background: linear-gradient(135deg, #bdc3c7, #95a5a6); color: #fff; }
.bg-bronze-badge { background: linear-gradient(135deg, #e67e22, #d35400); color: #fff; }
.bg-bronze { background-color: #cd7f32; }

.performer-item {
  transition: background-color 0.2s ease;
}
.performer-item:hover {
  background-color: #f8f9fa;
}

.daily-chart-container {
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 200px;
  padding: 10px 0;
  overflow-x: auto;
}
.daily-bar-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 25px;
  height: 100%;
  justify-content: flex-end;
}
.daily-bar {
  width: 100%;
  max-width: 30px;
  border-radius: 3px 3px 0 0;
  transition: height 0.3s ease;
  cursor: pointer;
}
.daily-bar:hover { opacity: 0.8; }
.bar-success { background: linear-gradient(180deg, #2ecc71, #27ae60); }
.bar-warning { background: linear-gradient(180deg, #f39c12, #e67e22); }
.bar-danger { background: linear-gradient(180deg, #e74c3c, #c0392b); }
.bar-primary { background: linear-gradient(180deg, #667eea, #764ba2); }
.daily-label {
  font-size: 0.65rem;
  color: #999;
  margin-top: 4px;
  white-space: nowrap;
}

.table th { font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.5px; }
.card { border-radius: 0.75rem; }
.border-4 { border-width: 4px !important; }

.bx-spin { animation: spin 1s linear infinite; }
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .daily-chart-container { height: 150px; }
  .daily-bar-wrapper { min-width: 18px; }
}
</style>